import flatpickr from "flatpickr";

document.addEventListener('alpine:init', () => {
    Alpine.data('admin_embed_metrics_show_x_data', () => ({
        date_range: '',
        date_range_picker: '',
        start_date: '',
        end_date: '',
        submit_url: '',
        total_media_downloads: 0,
        init() {
            // Initialize date range picker
            this.initialize_date_range_picker();
            this.submit_url = this.$refs.admin_embed_metrics_show_xref.dataset.submitUrl;
            this.total_media_downloads = parseInt(this.$refs.total_media_downloads_xref.dataset.totalMediaDownloads);
        },

        update_date_range(selectedDates) {
            // Update date range when user selects a new date range
            this.date_range = selectedDates.map(date => date.toISOString().split('T')[0])
            this.start_date = this.date_range[0];
            this.end_date = this.date_range[1];

            // Send data to backend
            if (this.start_date && this.end_date) {
                this.send_data_to_backend();
            }
        },

        initialize_date_range_picker() {
            const that = this;

            // Initialize date range picker
            this.date_range_picker = flatpickr(this.$refs.admin_embed_metrics_show_xref, {
                mode: 'range',
                dateFormat: 'Y-m-d',
                onChange: function (selectedDates) {
                    // Call the update function, ensuring the Alpine.js component's 'this' is used
                    that.update_date_range(selectedDates);
                },
            });
        },

        send_data_to_backend() {

            let that = this;

            // post fetch request using submit url
            fetch(this.submit_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({
                    start_date: this.start_date,
                    end_date: this.end_date
                })
            }).then(response => {
                return response.json();
            }).then(data => {
                console.log(data);
                that.total_media_downloads = data.download_number;
            }).catch(error => {
                console.error('Error:', error);
            });
        }
    }));
});
